import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { PaginatedParams, PaginatedResponse } from 'services/api/types'
import { UserSales } from '../types'

const loadUsersSales = (
  params: PaginatedParams
): PaginatedResponse<UserSales> => {
  const { page = 1, limit = 10 } = params

  return axios.get('/users/sales', {
    params: {
      page,
      limit,
      ...params
    }
  })
}

export function useLoadUsersSales(params: PaginatedParams) {
  return useQuery(['userSales', params], () => loadUsersSales(params), {
    keepPreviousData: true,
    onError: () =>
      toast.error('Não foi possível carregar os tipos de venda', {
        toastId: 'loadUsersSales'
      })
  })
}
